import { SimpleForm } from 'components/forms/SimpleForm';
import { SelectInput } from 'components/inputs/SelectInput';
import { TextInput } from 'components/inputs/TextInput';
import { sortBy } from 'lodash';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { STRING_LENGTHS } from 'utils/constants';
import * as yup from 'yup';

const WatcherTypeForm = ({
  onSubmit,
  watcherType,
  deviceTypeOptions,
  showButtons,
  isEditable = false,
  isLoading,
  fieldErrors,
}) => {
  const { t } = useTranslation();
  const schema = yup.object().shape({
    externalIdentifier: yup.string().max(STRING_LENGTHS.MEDIUM).required(),
    deviceType: yup.object().required(),
  });
  const navigate = useNavigate();

  const defaultValues = {
    externalIdentifier: watcherType?.externalIdentifier,
    deviceType: deviceTypeOptions.find(
      (option) => option.externalIdentifier === watcherType?.deviceType?.externalIdentifier
    ),
  };

  return (
    <SimpleForm
      validationSchema={schema}
      isEditable={isEditable}
      onSubmit={onSubmit}
      showButtons={showButtons}
      isLoading={isLoading}
      fieldErrors={fieldErrors}
      defaultValues={defaultValues}
      onGoBack={() => navigate('/watcher-types')}
    >
      {({ control, isFormEditable, reset }) => {
        useEffect(() => {
          reset(defaultValues);
        }, [watcherType, deviceTypeOptions, reset]);

        return (
          <>
            <TextInput
              control={control}
              name="externalIdentifier"
              label={t('entities:watcherType.attributes.externalIdentifier')}
              readOnly={!isFormEditable}
            />
            <SelectInput
              name="deviceType"
              control={control}
              label={t('entities:deviceType.nameSingular')}
              options={sortBy(deviceTypeOptions, ['externalIdentifier'])}
              data-testid="device-type-select"
              getOptionLabel={(option) => t(`entities:deviceType.values.${option.externalIdentifier}`)}
              readOnly={!isFormEditable}
              addNoneOption={false}
            />
          </>
        );
      }}
    </SimpleForm>
  );
};

export default WatcherTypeForm;
